import React from 'react';
import './PageLoadingSpinner.css';

/**
 * Same Bootstrap spinner as PracticeDashboard initial load
 * (practice-dashboard-loading-container + spinner-border text-primary).
 */
const PageLoadingSpinner = ({ minHeight = '400px', className = '' }) => (
  <div
    className={['page-loading-spinner-container', className].filter(Boolean).join(' ')}
    style={{ minHeight }}
  >
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);

export default PageLoadingSpinner;
